import { getNotificationServiceApi } from '@tempo-io/nexus-client';
import type { KyInstance } from 'ky';
import { getEnv } from '@/lib/utils/common/getEnv';
import { tempoApi } from '../tempoApi';

export const getNotificationApi = ({
  client = tempoApi(undefined, false),
}: {
  client?: KyInstance;
} = {}) => getNotificationServiceApi({ client, prefixUrl: getEnv().apiBaseUrl });
